import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Home = () => {
  const [showCookieConsent, setShowCookieConsent] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('qmax_cookie_consent')) {
      setTimeout(() => setShowCookieConsent(true), 2000);
    }
  }, []);

  const handleCookies = (accepted) => {
    localStorage.setItem('qmax_cookie_consent', accepted ? 'accepted' : 'declined');
    setShowCookieConsent(false);
  };

  const apps = [
    { id: 'guwahati-dealer', name: 'QMAX Guwahati', type: 'Dealer', version: '1.0.0', size: '72 MB', gradient: 'from-blue-500 to-blue-700', apkUrl: '/releases/qmax-guwahati-v1.0.0.apk', playStoreUrl: 'https://play.google.com/store/apps/details?id=com.sanibiz.qmaxguwahati', features: ['Browse Tiles', 'Request Quotes', 'Track Orders'], lastUpdated: '2025-12-25 15:57' },
    { id: 'silchar-dealer', name: 'QMAX Silchar', type: 'Dealer', version: '1.0.0', size: '76 MB', gradient: 'from-purple-500 to-purple-700', apkUrl: '/releases/qmax-silchar-v1.0.0.apk', playStoreUrl: 'https://play.google.com/store/apps/details?id=com.qmaxsilchar', features: ['Browse Tiles', 'Request Quotes', 'Track Orders'], lastUpdated: '2025-12-25 15:59' },
    { id: 'guwahati-salesperson', name: 'QMAX Guwahati', type: 'Salesperson', version: '1.0.2', size: '77 MB', gradient: 'from-emerald-500 to-teal-600', apkUrl: '/releases/qmax-guwahati-salesperson-v1.0.2.apk', playStoreUrl: 'https://play.google.com/store/apps/details?id=com.qmaxguwahati.salesperson', features: ['QR Scanner', 'Quote Management', 'Inventory'], lastUpdated: '2025-12-26 22:11' },
    { id: 'silchar-salesperson', name: 'QMAX Silchar', type: 'Salesperson', version: '1.0.2', size: '37 MB', gradient: 'from-orange-500 to-red-500', apkUrl: '/releases/qmax-silchar-salesperson-v1.0.2.apk', playStoreUrl: 'https://play.google.com/store/apps/details?id=com.qmaxsilchar.salesperson', features: ['QR Scanner', 'Quote Management', 'Inventory'], lastUpdated: '2025-12-26 22:11' }
  ];

  const features = [
    { icon: '📷', title: 'QR Scanning', desc: 'Scan tile QR codes for instant product details', color: 'bg-blue-500' },
    { icon: '🔍', title: 'Smart Search', desc: 'Filter by brand, size, finish, color & more', color: 'bg-purple-500' },
    { icon: '💰', title: 'Quick Quotes', desc: 'Request and track pricing quotes instantly', color: 'bg-green-500' },
    { icon: '📊', title: 'Live Inventory', desc: 'Real-time stock availability across locations', color: 'bg-orange-500' },
    { icon: '🖼️', title: 'HD Images', desc: 'Zoom into detailed product photographs', color: 'bg-pink-500' },
    { icon: '🔐', title: 'Secure Auth', desc: 'Enterprise-grade JWT authentication', color: 'bg-indigo-500' }
  ];

  const AppCard = ({ app }) => (
    <div className="bg-white rounded-2xl p-5 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
      <div className="flex items-center gap-3 mb-4">
        <img src="/qmax-logo.png" alt="QMAX" className="w-14 h-14 rounded-xl shadow" />
        <div>
          <h3 className="font-bold text-gray-900">{app.name}</h3>
          <p className="text-xs text-gray-500">{app.type} App • v{app.version}</p>
          {app.lastUpdated && <p className="text-xs text-blue-500">Updated: {app.lastUpdated}</p>}
        </div>
      </div>
      <div className="flex flex-wrap gap-1 mb-4">
        {app.features.map((f, i) => <span key={i} className="bg-gray-100 text-gray-600 text-xs px-2 py-1 rounded-full">{f}</span>)}
      </div>
      <div className="grid grid-cols-2 gap-2">
        <a href={app.apkUrl} className={`flex items-center justify-center px-3 py-2.5 bg-gradient-to-r ${app.gradient} text-white rounded-lg text-sm font-semibold hover:opacity-90 transition-all`}>
          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" /></svg>
          APK
        </a>
        <a href={app.playStoreUrl} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center px-3 py-2.5 bg-gray-100 text-gray-700 rounded-lg text-sm font-semibold hover:bg-gray-200 transition-all">
          <svg className="w-4 h-4 mr-1" viewBox="0 0 24 24" fill="currentColor"><path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/></svg>
          Play Store
        </a>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      <Navbar />

      {/* Hero */}
      <section className="pt-20 pb-12 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-block bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-xs font-semibold mb-4">📱 QMAX Mobile Apps</span>
          <img src="/qmax-logo.png" alt="QMAX" className="w-20 h-20 mx-auto rounded-2xl shadow-xl mb-4" />
          <h1 className="text-3xl md:text-5xl font-extrabold mb-3">
            <span className="bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">QMAX Online</span>
          </h1>
          <p className="text-lg md:text-xl text-gray-700 font-medium mb-2">Your Tile Business, In Your Pocket</p>
          <p className="text-gray-500 text-sm max-w-xl mx-auto mb-6">Browse tiles, create quotes, scan QR codes & manage your business efficiently.</p>
          <div className="flex gap-3 justify-center">
            <a href="#apps" className="px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all text-sm">View Apps</a>
            <a href="#download" className="px-6 py-3 bg-white text-gray-700 rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all border text-sm">How to Install</a>
          </div>
        </div>
      </section>

      {/* Apps */}
      <section id="apps" className="py-12 px-4 bg-white">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-2">Our Apps</h2>
          <p className="text-gray-500 text-center mb-8 text-sm">Choose the right app for your role</p>

          <div className="mb-10">
            <div className="flex justify-center mb-4"><span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-xs font-semibold">👔 For Dealers</span></div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-3xl mx-auto">
              {apps.filter(a => a.type === 'Dealer').map(app => <AppCard key={app.id} app={app} />)}
            </div>
          </div>

          <div>
            <div className="flex justify-center mb-4"><span className="bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full text-xs font-semibold">💼 For Sales Team</span></div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-3xl mx-auto">
              {apps.filter(a => a.type === 'Salesperson').map(app => <AppCard key={app.id} app={app} />)}
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section id="features" className="py-12 px-4">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-2">Features</h2>
          <p className="text-gray-500 text-center mb-8 text-sm">Everything you need to manage your tile business</p>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {features.map((f, i) => (
              <div key={i} className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg transition-shadow">
                <div className={`${f.color} text-white w-10 h-10 rounded-lg flex items-center justify-center mb-3 text-lg shadow`}>{f.icon}</div>
                <h3 className="font-bold text-gray-900 text-sm mb-1">{f.title}</h3>
                <p className="text-gray-500 text-xs leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Download Guide */}
      <section id="download" className="py-12 px-4 bg-white">
        <div className="max-w-3xl mx-auto">
          <div className="bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 rounded-2xl p-6 md:p-8 text-white shadow-xl">
            <h2 className="text-xl md:text-2xl font-bold text-center mb-6">Installation Guide</h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              {[
                { n: '1', t: 'Download', d: 'Get the APK file' },
                { n: '2', t: 'Enable', d: 'Allow unknown sources' },
                { n: '3', t: 'Install', d: 'Open & tap Install' },
                { n: '4', t: 'Login', d: 'Use your credentials' }
              ].map((s, i) => (
                <div key={i} className="bg-white/10 rounded-lg p-3 text-center">
                  <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-2 font-bold text-sm">{s.n}</div>
                  <h3 className="font-semibold text-sm">{s.t}</h3>
                  <p className="text-blue-100 text-xs mt-1">{s.d}</p>
                </div>
              ))}
            </div>
            <p className="text-center text-blue-100 text-xs mt-6">Need help? <a href="mailto:info@starsolutions.biz" className="underline">info@starsolutions.biz</a></p>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-10 px-4">
        <div className="max-w-2xl mx-auto grid grid-cols-3 gap-4 text-center">
          <div><div className="text-3xl md:text-4xl font-bold text-blue-600">4</div><p className="text-gray-500 text-xs">Apps</p></div>
          <div><div className="text-3xl md:text-4xl font-bold text-pink-600">1000+</div><p className="text-gray-500 text-xs">Tiles</p></div>
          <div><div className="text-3xl md:text-4xl font-bold text-emerald-600">24/7</div><p className="text-gray-500 text-xs">Access</p></div>
        </div>
      </section>

      <Footer />

      {/* Cookie Banner */}
      {showCookieConsent && (
        <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-4 z-50 shadow-2xl">
          <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-sm">🍪 We use cookies. <Link to="/cookie-policy" className="text-blue-400 underline">Learn more</Link></p>
            <div className="flex gap-2">
              <button onClick={() => handleCookies(false)} className="px-3 py-1.5 bg-gray-700 hover:bg-gray-600 rounded text-xs font-medium">Decline</button>
              <button onClick={() => handleCookies(true)} className="px-3 py-1.5 bg-blue-600 hover:bg-blue-700 rounded text-xs font-medium">Accept</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
